export default {
  text: 'Les empires du futur seront spirituels.',
  author: 'Winston Churchill',
  fontSize: '40px',
  lineHeight: '50px',
  color: '#b08335'
}
